export default "__VITE_ASSET__RRA3M7I3IG_3hD1v1D9tKA__"